import React from "react"
import { Heading } from "frontend/components/text"
import styles from "./PrivacyExplanation.module.css"
import { t } from "frontend/utils"

const PrivacyExplanation = () => {
  return (
    <div className={styles.container}>
      <Heading size={5} className={styles.heading}>
        {t("upload.form.privacy.public")}
      </Heading>
      <p className={styles.text}>{t("upload.form.privacy.public_detail")}</p>
      <Heading size={5} className={styles.heading}>
        {t("upload.form.privacy.private")}
      </Heading>
      <p className={styles.text}>{t("upload.form.privacy.private_detail")}</p>
      <Heading size={5} className={styles.heading}>
        {t("upload.form.privacy.onlyme")}
      </Heading>
      <p className={styles.text}>{t("upload.form.privacy.onlyme_detail")}</p>
    </div>
  )
}

export default PrivacyExplanation
